import { useApp } from "context";
import { Custom, Form } from "components";
import { Enums } from "utils";
import { Box } from "@mui/material";

type Props = {
  email: string;
  onClick: (
    step: number,
    email?: string | null,
    patientId?: number | null
  ) => void;
};

export const Register = (props: Props) => {
  const { t, theme } = useApp();

  const handleSubmit = (patientId: number) =>
    props.onClick &&
    props.onClick(Enums.EnumCheckInStep.MakeAppointment, null, patientId);

  const handleHome = () =>
    props.onClick && props.onClick(Enums.EnumCheckInStep.Email, null, null);

  return (
    <Box
      sx={{
        width: "80%",
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
        marginTop: -theme.margin.xl,
      }}
    >
      <Custom.Button
        variant="outlined"
        sx={{
          fontSize: theme.font.sm,
          marginBottom: theme.margin.xl,
        }}
        onClick={handleHome}
      >
        {t.action.return_check_in}
      </Custom.Button>
      <Form.QioskForm email={props.email} onSubmit={handleSubmit} />
    </Box>
  );
};
